<app-loader *ngIf="!isDataReady"></app-loader>
<div class="ui-g" *ngIf="isDataReady">   
    <div class="ui-sm-12 ui-md-12 ui-lg-10 ui-xl-8">
        <form [formGroup]="arrangerCommissionForm" (ngSubmit)="onSubmitArrangerCommissionForm()">
            <span class="ui-float-label" style="margin-bottom: 10px; margin-top: 10px;">
                <input id="commission-input" name="commission" type="number" pInputText style="width: 100%;" formControlName="commission"> 
                <label for="commission-input">{{ 'commission' | translate }} %</label>
            </span>          
    
            <div *ngIf="isEditingCommission == false"> 
                <div class="ui-sm-6 ui-md-5 ui-lg-3 ui-xl-2">
                    <button (click)="onEditCommission()" pButton type="button" label="{{ 'edit' | translate }}" class="ui-button-info"  style="width: 100%;"></button>
                </div>          
            </div> 
            <div class="ui-g" *ngIf="isEditingCommission == true">  
                <div class="ui-sm-6 ui-md-5 ui-lg-3 ui-xl-2">
                    <button pButton type="submit" [disabled]="!arrangerCommissionForm.valid" label="{{ 'save' | translate }}" class="ui-button-success" style="width: 100%;"></button>
                </div>  
                <div class="ui-sm-6 ui-md-5 ui-lg-3 ui-xl-2">
                    <button (click)="cancelForm()" pButton type="button" label="{{ 'cancel' | translate }}" class="ui-button-warning" style="width: 100%;"></button>
                </div>                 
            </div>
        </form>
    </div>
</div>